// iter v28 r372 — Costanti estratte da FotoEditor.jsx per ridurne la dimensione.
// Niente logica, solo configurazione statica (stili, room hints, modalità).
// I componenti React (icone) sono importati e ri-esportati come tali — i
// consumer continuano a usarli via `MODES[i].icon`.

import {
  Lightning, Armchair, Broom, Sparkle, MapTrifold, HouseLine,
} from "@phosphor-icons/react";

export const STAGE_STYLES = [
  { v: "casuale", l: "Automatico" },
  { v: "moderno", l: "Moderno" },
  { v: "scandinavo", l: "Scandinavo" },
  { v: "minimalista", l: "Minimalista" },
  { v: "classico", l: "Classico" },
  { v: "elegante", l: "Elegante" },          // iter v28 r39 — nuovo stile
  { v: "industriale", l: "Industriale" },
];

export const ROOM_HINTS = [
  { v: "", l: "Automatico" },
  { v: "soggiorno", l: "Soggiorno" },
  { v: "camera da letto", l: "Camera" },
  { v: "cucina", l: "Cucina" },
  { v: "cucina e soggiorno open space", l: "Cucina + soggiorno" },
  { v: "cameretta bambini", l: "Cameretta" },
  { v: "bagno", l: "Bagno" },
  { v: "sala da pranzo", l: "Sala da pranzo" },
  { v: "studio", l: "Studio" },
  // iter v28 r447 — outdoor categories
  { v: "terrazzo", l: "Terrazzo" },
  { v: "patio esterno", l: "Esterno (patio)" },
];

// iter v28 r39 — Elegante incluso nella scelta casuale
export const CONCRETE_STYLES = ["moderno", "scandinavo", "minimalista", "classico", "elegante", "industriale"];

export const MODES = [
  { v: "enhance",            l: "Migliora",            icon: Lightning, desc: "Luce, colori, ordine. Stessi mobili." },
  { v: "stage",              l: "Arreda spazio vuoto", icon: Armchair,  desc: "Spazio vuoto o cantiere → arredato in stile." },
  { v: "empty_room",         l: "Svuota spazio",       icon: Broom,     desc: "Spazio arredato → vuoto, perfetto per far vedere la metratura." },
  { v: "restyle",            l: "Rinnova arredo",      icon: Sparkle,   desc: "Stesso spazio, mobili nuovi." },
  // iter v30 r147 — Restyling esterno: la stessa casa "appena ristrutturata".
  { v: "exterior_restyle",   l: "Restyling esterno",   icon: HouseLine, desc: "Casa abbandonata → ristrutturata. Mantiene lo stile architettonico." },
  { v: "furnish_plan",       l: "Arreda pianta",       icon: MapTrifold, desc: "Pianta 2D → mobili disegnati nelle stanze." },
];

// "casuale" is a frontend convenience: pick a random concrete style to send
// to the backend (which only accepts the canonical names).
// iter v28 r39 — `casuale` resolver: pesca uno degli stili concreti (Elegante incluso)
export const resolveStyle = (s) =>
  s === "casuale"
    ? CONCRETE_STYLES[Math.floor(Math.random() * CONCRETE_STYLES.length)]
    : s;
